import NavBar from "@/components/woost/NavBar";
import Footer from "@/components/woost/Footer";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      <NavBar />

      <motion.div
        className="container mx-auto px-4 py-20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Link
          to="/"
          className="inline-flex items-center text-woost-blue mb-8 hover:underline"
        >
          <ArrowLeft size={16} className="mr-2" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>

        <div className="prose prose-lg max-w-none">
          <p>Last Updated: May 17, 2025</p>

          <h2>1. Introduction</h2>
          <p>
            At Woost, we respect your privacy and are committed to protecting
            your personal data. This Privacy Policy explains how we collect,
            use, disclose, and safeguard your information when you use our
            mobile application and website (collectively, the "Platform").
          </p>
          <p>
            Please read this Privacy Policy carefully. If you do not agree with
            the terms of this Privacy Policy, please do not access the Platform.
          </p>

          <h2>2. Information We Collect</h2>
          <h3>2.1 Personal Data</h3>
          <p>
            When you register an account, we may collect the following personal
            information:
          </p>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Profile picture</li>
            <li>Social media handles and follower metrics (for Creators)</li>
            <li>Company information (for Brands)</li>
            <li>Payment information</li>
          </ul>

          <h3>2.2 Usage Data</h3>
          <p>
            We may also collect information about how you access and use our
            Platform, including:
          </p>
          <ul>
            <li>Log data (IP address, browser type, pages visited)</li>
            <li>Device information (hardware model, operating system)</li>
            <li>Location data (with your consent)</li>
            <li>Cookies and similar tracking technologies</li>
          </ul>

          <h2>3. How We Use Your Information</h2>
          <p>
            We use the information we collect for various purposes, including
            to:
          </p>
          <ul>
            <li>Provide, maintain, and improve our Platform</li>
            <li>Process transactions and send related information</li>
            <li>
              Connect Brands with suitable Creators based on campaign
              requirements
            </li>
            <li>Send notifications and updates about campaigns</li>
            <li>Respond to your comments, questions, and requests</li>
            <li>Monitor and analyze trends, usage, and activities</li>
            <li>Detect, prevent, and address technical issues</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2>4. Sharing Your Information</h2>
          <p>We may share your information in the following circumstances:</p>
          <ul>
            <li>
              Between Brands and Creators when a match is made for a campaign
            </li>
            <li>With service providers who perform services on our behalf</li>
            <li>To comply with legal obligations</li>
            <li>
              In connection with a business transfer (merger, acquisition, etc.)
            </li>
            <li>With your consent</li>
          </ul>

          <h2>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to
            protect your personal data against unauthorized or unlawful
            processing, accidental loss, destruction, or damage. However, no
            method of transmission over the Internet or electronic storage is
            100% secure, and we cannot guarantee absolute security.
          </p>

          <h2>6. Your Data Protection Rights</h2>
          <p>
            Depending on your location, you may have the following rights
            regarding your personal data:
          </p>
          <ul>
            <li>Access: You can request copies of your personal data.</li>
            <li>
              Rectification: You can request that we correct inaccurate data.
            </li>
            <li>
              Erasure: You can request that we delete your data under certain
              circumstances.
            </li>
            <li>
              Restriction: You can request that we restrict the processing of
              your data.
            </li>
            <li>
              Data portability: You can request the transfer of your data to
              another organization.
            </li>
            <li>
              Objection: You can object to our processing of your data under
              certain circumstances.
            </li>
          </ul>

          <h2>7. Children's Privacy</h2>
          <p>
            Our Platform is not intended for children under the age of 18. We do
            not knowingly collect personal information from children under 18.
            If you are a parent or guardian and believe that your child has
            provided us with personal information, please contact us so that we
            can delete such information.
          </p>

          <h2>8. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page
            and updating the "Last Updated" date. You are advised to review this
            Privacy Policy periodically for any changes.
          </p>

          <h2>9. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at:
          </p>
          <p>
            Woost Internet Private Limited
            <br />
            H-102, Third floor, Sector 63 Rd, H Block, Sector 63, Noida, Uttar
            Pradesh 201301
            <br />
            Email: partners@woost.io
          </p>
        </div>
      </motion.div>

      <Footer />
    </div>
  );
};

export default Privacy;
